import { useState } from 'react';

interface Props<T> {
    items: T[];
    initialVisibleItems: number;
}

const getInitialItemsCount = (totalItems: number, itemsToShow: number) =>
    itemsToShow > totalItems ? totalItems : itemsToShow;

export const useCollapsibleItems = <T>({ items, initialVisibleItems }: Props<T>) => {
    const [isShowingMore, setShowingMore] = useState(false);

    const initialItemsCount = getInitialItemsCount(items.length, initialVisibleItems);
    const visibleItems = items.slice(0, initialItemsCount);
    const collapsedItems = items.slice(initialItemsCount);

    return {
        isShowingMore,
        visibleItems,
        collapsedItems,
        showCollapsedItems: () => setShowingMore(true),
        hideCollapsableItems: () => setShowingMore(false),
    };
};
